import { useEffect, useRef } from "react"

export const useRecaptchaObserver = ({
  onChallengeHide,
  onChallengeVisible,
}: {
  onChallengeHide?: CallableFunction
  onChallengeVisible?: CallableFunction
}) => {
  const observersRef = useRef<{
    mainObserver: MutationObserver | null
    reCaptchaChallengeClosureObserver: MutationObserver | null
  }>({
    mainObserver: null,
    reCaptchaChallengeClosureObserver: null,
  })

  const isObserverActiveRef = useRef(false)

  useEffect(() => {
    console.debug("useRecaptchaObserver")

    // Prevent multiple observers from being created
    if (isObserverActiveRef.current) {
      console.debug("Observer already active, skipping creation")
      return
    }

    isObserverActiveRef.current = true
    let recaptchaIframe = null
    let parentRecaptchaContainerDiv = null

    const mainObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          parentRecaptchaContainerDiv = mutation.addedNodes[0]
          console.debug(
            "have got the parent Recaptcha Container Div",
            parentRecaptchaContainerDiv,
          )
          if (parentRecaptchaContainerDiv instanceof HTMLElement) {
            recaptchaIframe = parentRecaptchaContainerDiv.querySelectorAll(
              'iframe[title*="recaptcha challenge"]',
            )
          }

          if (recaptchaIframe?.length) {
            observersRef.current.reCaptchaChallengeClosureObserver =
              new MutationObserver((mutationsAtSecondLevel) => {
                for (const mutation of mutationsAtSecondLevel) {
                  if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "style"
                  ) {
                    const target = mutation.target as HTMLElement
                    const visibility =
                      window.getComputedStyle(target).visibility

                    if (visibility === "visible") {
                      //operation when challenge gets visible
                      console.debug("The challenge is visible")
                      onChallengeVisible && onChallengeVisible()
                    } else if (visibility === "hidden") {
                      // in case of close or dismiss -> function is called
                      console.debug("The challenge got hidden")
                      onChallengeHide && onChallengeHide()
                    }
                  }
                }
              })

            observersRef.current.reCaptchaChallengeClosureObserver.observe(
              parentRecaptchaContainerDiv,
              {
                attributes: true,
                attributeFilter: ["style"],
              },
            )
          }
        }
      }
    })

    observersRef.current.mainObserver = mainObserver

    mainObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
      attributeOldValue: false,
      characterData: false,
      characterDataOldValue: false,
    })

    return () => {
      isObserverActiveRef.current = false

      if (observersRef.current.mainObserver) {
        observersRef.current.mainObserver.disconnect()
        observersRef.current.mainObserver = null
      }

      if (observersRef.current.reCaptchaChallengeClosureObserver) {
        observersRef.current.reCaptchaChallengeClosureObserver.disconnect()
        observersRef.current.reCaptchaChallengeClosureObserver = null
      }
    }
  }, [onChallengeHide, onChallengeVisible])
}
